import GroupApi from '@/api/Group'

export default  {
  state: {
    claims: undefined,
    groupList: [],
  },
  mutations: {
    AUTHENTICATION_SET_CLAIMS (state, claims) {
      state.claims = claims
    },
    SET_GROUP_LIST (state, list) {
      state.groupList = list
    },
    ROUTE_ADD_CHILDREN (state, { parent, children }) {
      if (!state.routes || !state.routes.length) {
        return
      }

      const routes = state.routes.map((route, i) => {
        // don't mutate the original route object
        if (route.name !== parent) {
          return route
        }

        return {
          name: route.name,
          path: route.path,
          meta: route.meta,
          component: route.component,
          children
        }
      })

      state.routes = routes
    }
  },
  actions: {
    RELOAD_GROUP_LIST ({ commit, getters }) {
      GroupApi.getGroupList(getters.http)
        .then(groupList => {
          commit('SET_GROUP_LIST', groupList)
        })
    },
    AUTHENTICATION_SET_CLAIMS ({ commit }, claims) {
      commit('AUTHENTICATION_SET_CLAIMS', claims)
    },
  },
  getters: {
    groupList: state => {
      return state.groupList
    },
    authenticationClaims: state => {
      return state.claims
    },
    isAdmin: state => {
      return state.claims && state.claims.userType === 0
    },
    authenticationToken: state => {
      return state.authentication.token
    },
    languages: state => {
      return state.ui.languages
    },
    currentLanguage: state => {
      return state.ui.language
    },
    currentLocale: state => {
      return state.ui.language.locale
    },
  }
}
